import styled from 'styled-components';
import THEME from '../theme';
const LineTrough = styled.h3 `
  position: relative;
  text-align: center;
  text-transform: uppercase;
  z-index: 0;

  span {
    background-color: ${(props) => props.color || 'white'};
    padding: 0 10px;
  }

  &::before {
    border-bottom: 1px solid ${THEME.DARK_COLOR_SECONDARY};
    -webkit-box-shadow: 0 1px 0 0 red;
    -moz-box-shadow: 0 1px 0 0 red;
    box-shadow: 0 1px 0 0 ${THEME.DARK_COLOR_SECONDARY};
    content: '';
    margin: 0 auto;
    position: absolute;
    top: 45%;
    left: 0;
    right: 0;
    width: 100%;
    z-index: -1;
  }
`;
export default LineTrough;
//# sourceMappingURL=LineThrough.js.map